import React, { useEffect, useState } from "react";
import type { SatchelApiClient } from "../../../services/satchelApi";
import { NetworkPill } from "./NetworkPill";

const POLL_MS = 30_000;

type ShardState = "ready" | "not_ready" | "unreachable";

const PROBLEM: Record<Exclude<ShardState, "ready">, { label: string; dot: string }> = {
  not_ready: { label: "Not ready", dot: "bg-sa-warning" },
  unreachable: { label: "Unreachable", dot: "bg-sa-danger" },
};

export const SHARD_NAME = "F1r3fly-shard-02";

/**
 * The F1r3fly shard, named like the other networks; it says more only when
 * the wallet's server finds the shard not ready or unreachable. Checked every
 * 30 seconds.
 */
export const ShardStatusPill: React.FC<{ api: Pick<SatchelApiClient, "getNetwork"> }> = ({
  api,
}) => {
  const [state, setState] = useState<ShardState | null>(null);

  useEffect(() => {
    let current = true;
    const check = () =>
      api.getNetwork().then(
        ({ f1r3fly }) => {
          if (!current) return;
          setState(!f1r3fly.status ? "unreachable" : f1r3fly.status.ready ? "ready" : "not_ready");
        },
        () => current && setState("unreachable"),
      );
    void check();
    const timer = setInterval(check, POLL_MS);
    return () => {
      current = false;
      clearInterval(timer);
    };
  }, [api]);

  if (!state) return null;
  if (state === "ready") return <NetworkPill>{SHARD_NAME}</NetworkPill>;
  const { label, dot } = PROBLEM[state];
  return (
    <span role="status">
      <NetworkPill dot={dot}>
        {SHARD_NAME} · {label}
      </NetworkPill>
    </span>
  );
};
